// extracted by mini-css-extract-plugin
export default {"icon":"Partners_icon__7y7p+","partners":"Partners_partners__+hhxK"};